import { theme } from '@theme';
import styled from 'styled-components';

type IconProps = {
  type: string;
  size?: number;
  color?: string;
  title?: string;
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number;
  visibilty?: string;
  additionalClassName?: string;
  zIndex?: number;
  paddingBottom?: number;
  top?: number;
  padding?: number;
  fontWeight?: number;
};

const getClassName = (type: string, additionalClassName?: string) => {
  let className = `am-icon-${type}`;

  if (additionalClassName !== undefined) {
    className = `${className} ${additionalClassName}`;
  }

  return className;
};

export const Icon = styled.span.attrs<IconProps>((props) => ({
  className: `${getClassName(props.type, props.additionalClassName)}`,
  title: `${props.title ?? ''}`,
}))<IconProps>`
  position: relative;
  font-size: ${(props) => props.size}px;
  padding: ${(props) => (props.padding ? props.padding + 'px' : 0 + 'px')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop + 'px' : 0 + 'px')};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft + 'px' : 0 + 'px')};
  margin-right: ${(props) => (props.marginRight ? props.marginRight + 'px' : 0 + 'px')};
  ${(props) => props.color && `color: ${props.color}`};
  visibility: ${(props) => (props.visibilty ? props.visibilty : 'visible')};
  ${(props) => props.zIndex && `z-index: ${props.zIndex}`};
  padding-bottom: ${(props) => (props.paddingBottom ? props.paddingBottom + 'px' : 0 + 'px')};
  top: ${(props) => (props.top ? props.top + 'px' : 0 + 'px')};
  font-weight: ${(props) =>
    props.fontWeight ? props.fontWeight : theme.typography.fontWeights.normal};
`;

export const CenterIcon = styled(Icon).attrs<IconProps>((props) => ({
  className: `${getClassName(props.type, props.additionalClassName)}`,
}))<IconProps>`
  align-items: center;
  margin-left: 5px;
`;

type RoundedIconProps = {
  backgroundColor: string;
  color?: string;
  marginLeft?: number;
  marginRight?: number;
};
export const RoundedIcon = styled(Icon)<RoundedIconProps>`
  background-color: ${(props) => props.backgroundColor ?? props.theme.palette.white};
  color: ${(props) => props.theme.palette.blue};
  border-radius: 50%;
  padding: 5px;
  vertical-align: text-bottom;
  margin-left: ${(props) => props.marginLeft ?? 0}px;
  margin-right: ${(props) => props.marginRight ?? 0}px;
`;
